import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Tools from "./pages/Tools";
import ToolDetail from "./pages/ToolDetail";
import Consulting from "./pages/Consulting";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import Billing from "./pages/Billing";
import OAuthCallback from "./pages/OAuthCallback";
import LandingPage from "./pages/LandingPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminTools from "./pages/admin/AdminTools";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminRuns from "./pages/admin/AdminRuns";
import AdminSettings from "./pages/admin/AdminSettings";
import BudgetPlanner from "./pages/BudgetPlanner";
import Trust from "./pages/Trust";
import Outcomes from "./pages/Outcomes";
import Partners from "./pages/Partners";
import Newsroom from "./pages/Newsroom";
import AIRadar from "./pages/AIRadar";
import AIServices from "./pages/AIServices";
import InsightsHub from "./pages/InsightsHub";
import AIReadiness from "./pages/AIReadiness";
import Playbooks from "./pages/Playbooks";
import TemplatesLibrary from "./pages/TemplatesLibrary";
import LearningCenter from "./pages/LearningCenter";
import { trackGooglePageView } from "./services/googleAnalytics";
import { SiteSettingsProvider } from "./hooks/useSiteSettings";

export default function App() {
  const location = useLocation();

  useEffect(() => {
    trackGooglePageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <SiteSettingsProvider>
    <Routes>
      {/* OAuth callback — no Layout chrome */}
      <Route path="/oauth-callback" element={<OAuthCallback />} />
      {/* Standalone landing pages — no Layout chrome */}
      <Route path="/lp/:slug" element={<LandingPage />} />

      {/* Main app with Layout */}
      <Route
        path="*"
        element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tools" element={<Tools />} />
              <Route path="/tools/:slug" element={<ToolDetail />} />
              <Route path="/tools/budget-planner" element={<BudgetPlanner />} />
              <Route path="/consulting" element={<Consulting />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/tools" element={<AdminTools />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/runs" element={<AdminRuns />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/trust" element={<Trust />} />
              <Route path="/outcomes" element={<Outcomes />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/newsroom" element={<Newsroom />} />
              <Route path="/radar" element={<AIRadar />} />
              <Route path="/ai" element={<AIServices />} />
              <Route path="/insights" element={<InsightsHub />} />
              <Route path="/ai-readiness" element={<AIReadiness />} />
              <Route path="/playbooks" element={<Playbooks />} />
              <Route path="/templates" element={<TemplatesLibrary />} />
              <Route path="/academy" element={<LearningCenter />} />
            </Routes>
          </Layout>
        }
      />
    </Routes>
    </SiteSettingsProvider>
  );
}
